import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.drawer + 100,
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    border: 0,
  },
  logo: {
    display: 'block',
    width: 'auto',
    maxWidth: 130,
    maxHeight: 40,
    objectFit: 'contain',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 110,
      maxHeight: 32,
    },
  },
  userButton: {
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(0.5),
  },
}))

export default useStyles
